import React from 'react'
import { ButtonBookmarkIcon } from '../../../components'
import { useViewport, viewportBreakpoint } from '../../../utils'

const Card = ({data, bookmark}) => {
  const {
    image,
    date,
    organization,
    title,
  } = data

  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  const boxShadow = isMobile ? '0px 4px 10px rgba(0, 0, 0, 0.05)' : '0px 4px 20px rgba(0, 0, 0, 0.05)'

  return (
    <div
      className="bg-white rounded p-3 lg:p-5 h-full"
      style={{boxShadow: boxShadow}}
    >
      <div
        className="w-full bg-no-repeat bg-cover bg-center mb-3 lg:mb-4 rounded p-2"
        style={{backgroundImage: `url('${image}')`, height: isMobile ? '76px' : '180px'}}
      >
      {
        bookmark &&
        <ButtonBookmarkIcon className="ml-auto bg-white"/>
      }
      </div>
      <p className="text-gray-999 text-xs mb-2">
        {
          organization &&
          <span>{organization} /<br/></span>
        }
        {date}
      </p>
      <h3 className="lg:text-lg font-bold lg:mb-2 font-primary">{title}</h3>
    </div>
  )
}

export { Card }
